import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Spin } from "antd";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { useResetPassword } from "@companion-core/shared/app/Queries";
import { JPInputError } from "@companion-core/shared/app/Components/Inputs/JPInputError";
import { IndependentDynamicForm } from "@companion-core/shared/app/Components/DynamicForm/IndependentDynamicForm";
import { loadFormFromPath } from "@companion-core/shared/app/Utils/dynamicForm";

const ResetPassword = () => {
  const {
    mutate: resetPassword,
    isPending,
    isSuccess,
  } = useResetPassword((error) => {
    const errorReason = error?.response?.data?.error_description?.password?.[0];
    const clientMessage =
      errorReason === "known_password"
        ? "password.resetV2.errors.sameAsCurrent"
        : "password.resetV2.errors.unknown";
    setError(t(clientMessage));
    const jsonForm = loadFormFromPath(
      `common-forms/${jwt.secret_question ? "password/resetWithQuestion" : "password/reset"}`,
    );
    if (jwt.secret_question && jsonForm)
      jsonForm.steps[0].fields[1].initialValue = jwt.secret_question;
    setForm(jsonForm);
  });

  const { t } = useTranslation();
  const { token } = useParams();
  const jwt = jwtDecode<JwtPayload & { secret_question?: string | null }>(token ?? "");
  const jsonForm = loadFormFromPath(
    `common-forms/${jwt.secret_question ? "password/resetWithQuestion" : "password/reset"}`,
  );
  if (jwt.secret_question && jsonForm)
    jsonForm.steps[0].fields[1].initialValue = jwt.secret_question;
  const [form, setForm] = useState(jsonForm);
  const [error, setError] = React.useState<string>("");

  return (
    <div className="passwordManagement__container d-flex justify-content-center">
      <div className="passwordManagement__title-container">
        <span className="super-title-3 d-flex align-self-center">
          {isSuccess ? t("password.resetV2.success.title") : t("password.resetV2.title")}
        </span>
      </div>

      {isSuccess && (
        <a href="/login" className="body-text-5 text-decoration-none">
          {t("password.resetV2.success.buttons.back")}
        </a>
      )}
      {error ? <JPInputError testID="error_reset_password" error={error} /> : null}
      {!isSuccess && (
        <>
          <IndependentDynamicForm
            name="resetPassword"
            initialFormJSON={form}
            onSubmitForm={(payload) => {
              if (!token) return;
              setError("");
              const { password, question, answer } = payload as {
                password: string;
                question?: string;
                answer?: string;
              };
              resetPassword({ password, token, question, answer });
            }}
          />
        </>
      )}
      {isPending && <Spin data-testid="resetPassword__loader" size="large" />}
    </div>
  );
};

export default ResetPassword;
